module.exports = __webpack_public_path__ + "static/img/designGuide1.a8c1636.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/designGuide1.png
// module id = onZt
// module chunks = 2